import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';

import './Home.scss';

import { BrandBand } from '../../common/components';
import { Header, AssetClassOverview, McMenu } from '../components/';

export class AssetClassDashboard extends Component {
  componentDidMount() {
    this.props.actions.getRules();
  }

  render() {
    const { assets, ...others } = this.props;
    return (
      <McMenu
        flags={this.props.flags}
        history={this.props.history}
        route="/classes"
      >
        <BrandBand>
          <Header route={this.props.match} />
          <AssetClassOverview assets={assets} {...others} />
        </BrandBand>
      </McMenu>
    );
  }
}

AssetClassDashboard.propTypes = {
  actions: PropTypes.object,
  assets: PropTypes.object.isRequired,
  modals: PropTypes.object,
  flags: PropTypes.object,
  rules: PropTypes.object.isRequired,
  location: PropTypes.object,
  toast: PropTypes.object
};

function mapStateToProps(state) {
  return {
    assets: state.ecs.assets,
    modals: state.modals,
    flags: state.ecs.flags,
    rules: state.ecs.rules?.data?.rules,
    toast: state.toast
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetClassDashboard);
